import { render, staticRenderFns } from "./SleekNotificationCard.vue?vue&type=template&id=a8abc474&scoped=true"
import script from "./SleekNotificationCard.vue?vue&type=script&lang=js"
export * from "./SleekNotificationCard.vue?vue&type=script&lang=js"
import style0 from "./SleekNotificationCard.vue?vue&type=style&index=0&id=a8abc474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8abc474",
  null
  
)

export default component.exports